module.exports = __webpack_public_path__ + "img/new-approaches-to-scientific-realism-cover.6bbf202e.jpg";